import { IPlayerDataLabels, IStatistic } from '../../../../packages/types';
import { playerStatisticLabels } from '../../../docs/.storybook/labels-value';

const DEFAULT_FORWARDER_STATISTICS = ['played', 'goals', 'shots', 'assists', 'minutes', 'yellow_cards'];

const DEFAULT_KEEPER_STATISTICS = ['played', 'saves', 'cleansheets', 'conceded', 'caught_ball', 'penalties_saved'];

export const getPlayerStatisticRows = (
  position: string | undefined,
  statistics: IStatistic[] | undefined,
  scheme?: string[],
  dataLabels?: IPlayerDataLabels,
) => {
  const statRowsPositions =
    !scheme || scheme.length < 3 ? (position === 'KEEPER' ? DEFAULT_KEEPER_STATISTICS : DEFAULT_FORWARDER_STATISTICS) : scheme;

  const defaultLabels = playerStatisticLabels as IPlayerDataLabels;

  const rows = statRowsPositions
    .map((statName) => {
      const name = dataLabels && dataLabels[statName] ? dataLabels[statName] : defaultLabels[statName];
      const value = statistics?.find((s) => s.name === statName)?.value;
      return { name: name ?? '', value: value ?? '-' };
    })
    .slice(0, 6);

  return rows;
};
